function initializeTabsEvents(tabSectionIndex, tabSection) {
    const $tabContentsContainer = $(tabSection).find(".pd-tabs-section__content");
    const $tabsNavHeader        = $(tabSection).find(".pd-tabs-section__nav");
    const $tabsButtons          = $tabsNavHeader.find(".pd-tabs-section__button");

    $tabsButtons.each(function (index, tabButton) {
        $(tabButton).on("click", function (evt) {
            const $currentButton = $(evt.currentTarget);

            tabClickEffect(index, $currentButton, $tabsNavHeader);
            unactiveAllTabs();
            $currentButton.addClass("active");

            const contentDOMSelector = $currentButton.data("target");

            hideAllTabsContent();
            showTabContentBySelector(`#${contentDOMSelector}`);
        });
    });

    const unactiveAllTabs = () => {
        $tabsButtons.removeClass("active");
    };

    const hideAllTabsContent = () => {
        $tabContentsContainer.find("> div").hide("fast");
    };

    const showTabContentBySelector = (contentDOM) => {
        $(contentDOM).parent().show("fast");
    };
}

function tabClickEffect(index, $tabButton, $tabsNavHeader) {
    const widthButtonsUntilCurrent =
        $tabsNavHeader.find(".pd-tabs-section__button")
            .toArray()
            .reduce((acc, btn, i) =>
                i < index ?
                    acc + $(btn).innerWidth() : acc
            , 0);

    const OFFSET_SCROLL_LEFT = 50;
    const TABS_GAP           = 16;

    const tabsNavHeaderGap                = $tabsNavHeader.css("gap");
    const widthButtonsUntilCurrentWithGap = `calc(${widthButtonsUntilCurrent}px + ${tabsNavHeaderGap} * ${index})`;

    const tabButtonOffsetLeft     = $tabButton.offset().left;
    const tabButtonWidth          = $tabButton.outerWidth();
    const tabsNavHeaderScrollLeft = $tabsNavHeader.scrollLeft();
    const scrollWidth             = $tabsNavHeader[0].scrollWidth;
    const tabsNavHeaderWidth      = $tabsNavHeader.width();
    const tabButtonOffsetRight    = tabButtonOffsetLeft + tabButtonWidth;


    if (window.innerWidth >= 992) {
        if (index === 0) {
            $tabsNavHeader.animate({
                scrollLeft: 0
            }, 300);
        } else if ($tabsNavHeader.children().length === (index + 1)) {
            $tabsNavHeader.animate({
                scrollLeft: scrollWidth
            }, 300);
        } else if (tabButtonOffsetLeft < tabsNavHeaderScrollLeft) {
            $tabsNavHeader.animate({
                scrollLeft: tabButtonOffsetLeft - $tabsNavHeader.offset().left
            }, 300);
        } else if (tabButtonOffsetRight > tabsNavHeaderScrollLeft + tabsNavHeaderWidth) {
            $tabsNavHeader.animate({
                scrollLeft: tabButtonOffsetRight - tabsNavHeaderWidth + $tabsNavHeader.offset().left
            }, 300);
        }
    } else {
        if (index === 0) {
            $tabsNavHeader.animate({
                scrollLeft: 0
            }, 300);
        } else if ($tabsNavHeader.children().length === (index + 1)) {
            $tabsNavHeader.animate({
                scrollLeft: scrollWidth
            }, 300);
        } else {
            $tabsNavHeader.animate({
                scrollLeft: (widthButtonsUntilCurrent + TABS_GAP * index) - OFFSET_SCROLL_LEFT
            }, 300);
        }
    }

    $tabsNavHeader.css("--tabBackgroundPosition", widthButtonsUntilCurrentWithGap);
    $tabsNavHeader.css("--tabBackgroundWidth", `${$tabButton.innerWidth()}px`);
}

function activeFirstTab(tabSection) {
    const $tabsNavHeader = $(tabSection).find(".pd-tabs-section__nav");
    const $tabsButtons   = $tabsNavHeader.find(".pd-tabs-section__button");

    $tabsButtons.first().trigger("click");
}

function InitializeTabs() {
    console.log("tabsSection.js loaded");

    const $tabsSections = $(".pd-tabs-section");

    $tabsSections.each(function (index, tabSection) {
        initializeTabsEvents(index, tabSection);
        activeFirstTab(tabSection);
    });
}

export default InitializeTabs;
